import React, { useState } from 'react';
import ProfileField from './ProfileField';
import styles from '@/styles/components/profile/ProfileSection.module.css';

export interface ProfileSectionProps {
  username: string;
  email: string;
  token: string;
  onChangeUsername: () => void;
  onChangeEmail: () => void;
  onChangePassword: () => void;
  onGenerateToken: () => void;
}

const ProfileSection: React.FC<ProfileSectionProps> = ({
  username,
  email,
  token,
  onChangeUsername,
  onChangeEmail,
  onChangePassword,
  onGenerateToken,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopyToken = async () => {
    try {
      await navigator.clipboard.writeText(token);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      // Silently handle copy failure
    }
  };

  // Mask the token for display (show first 8 and last 4 characters)
  // Use a fixed-length middle mask to prevent layout overflow
  const getMaskedToken = (token: string) => {
    if (!token || token.length < 12) {
      return token;
    }
    const middleMask = '•'.repeat(12);
    return `${token.substring(0, 8)}${middleMask}${token.substring(token.length - 4)}`;
  };

  return (
    <>
      {/* Account Details Section */}
      <div className={styles.container}>
        <h3 className={styles.sectionTitle}>Account details</h3>

        <ProfileField
          icon="/icons/profile_page/user.svg"
          iconAlt="User"
          value={username}
          actions={[
            { label: 'Change username', onClick: onChangeUsername }
          ]}
        />

        <ProfileField
          icon="/icons/profile_page/email.svg"
          iconAlt="Email"
          value={email}
          actions={[
            { label: 'Change email', onClick: onChangeEmail }
          ]}
        />
      </div>

      {/* Safety Section */}
      <div className={styles.container}>
        <h3 className={styles.sectionTitle}>Safety</h3>

        <ProfileField
          icon="/icons/profile_page/lock.svg"
          iconAlt="Password"
          value="••••••••"
          actions={[
            { label: 'Change password', onClick: onChangePassword }
          ]}
        />
      </div>

      {/* Token Section */}
      <div className={styles.container}>
        <h3 className={styles.sectionTitle}>Token</h3>

        <ProfileField
          icon="/icons/profile_page/key.svg"
          iconAlt="API Token"
          value={getMaskedToken(token)}
          isMonospace={true}
          actions={[
            {
              label: copied ? 'Copied!' : 'Copy',
              onClick: handleCopyToken
            },
            {
              label: 'Generate new token',
              onClick: onGenerateToken
            }
          ]}
        />
      </div>
    </>
  );
};

export default ProfileSection;